import { render, staticRenderFns } from "./jobQuestion.vue?vue&type=template&id=6352462a&scoped=true"
import script from "./jobQuestion.vue?vue&type=script&lang=js"
export * from "./jobQuestion.vue?vue&type=script&lang=js"
import style0 from "./jobQuestion.vue?vue&type=style&index=0&id=6352462a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6352462a",
  null
  
)

export default component.exports